import { SelectInput } from '@interstate/components/SelectInput';
import type { DealTabs } from '@makemydeal/dr-shared-types';
import { useFlexBuyTermField } from './hooks/useFlexBuyTermField';

export const FlexBuyTermSelectInput = ({ tab }: { tab?: DealTabs }) => {
    const { label, selectProps } = useFlexBuyTermField({ tab });

    return <SelectInput id={label} label={label} {...selectProps} />;
};
